import ApiServiceMixin from "@/mixins/ApiServiceMixin";
import UtilitiesMixins from "@/mixins/UtilitiesMixin";
import MessagesMixin from "@/mixins/MessagesMixins";

export default {
	name: "PermissionsMixins",
	data() {
		return {
			rootUser: ["root"],
		};
	},
	methods: {
		isRootUser() {
			return this.userHasPermission(this.rootUser);
		},
		isRootOrAdmin() {
			return this.userHasPermission(["root", "admin"]);
		},
		userHasPermission(checkPermissions) {
			var found = false;

			if (this.userPemissions) {
				checkPermissions.forEach((perm) => {
					if (this.userPemissions) {
						var foundAt = this.userPemissions.findIndex((i) => i == perm);
						if (foundAt >= 0) {
							found = true;
							return;
						}
					}
				});
			}

			return found;
		},
		userHasPermissions(checkPermissions) {
			var found = false;

			if (this.userPemissions) {
				checkPermissions.forEach((perm) => {
					if (this.userPemissions) {
						var foundAt = this.userPemissions.findIndex((i) => i == perm);
						if (foundAt == -1) {
							return;
						}
					}
				});
			}

			return found;
		},
	},
	computed: {
		userPermissionsFilter() {
			var menuItems = {
				root: this.userHasPermission(["root"]),
				admin: this.userHasPermission(["root", "admin"]),
				partneradmin: this.userHasPermission([
					"root",
					"admin",
					"partner.admin",
				]),
				agentadmin: this.userHasPermission([
					"root",
					"admin",
					"partner.admin",
					"agent.admin",
				]),
				showDashboard: this.userHasPermission([
					"root",
					"admin",
					"dashboard.viewtransactions",
					"dashboard.viewaccounting",
				]),
				viewdashboardtransactions: this.userHasPermission([
					"root",
					"admin",
					"dashboard.viewtransactions",
				]),
				viewdashboardaccounting: this.userHasPermission([
					"root",
					"admin",
					"dashboard.viewaccounting",
				]),

				viewusers: this.userHasPermission(["root", "admin", "users.view"]),
				addusers: this.userHasPermission(["root", "admin", "users.add"]),
				editusers: this.userHasPermission(["root", "admin", "users.edit"]),
				deactivateusers: this.userHasPermission([
					"root",
					"admin",
					"users.deactivate",
				]),

				approveusers: this.userHasPermission([
					"root",
					"admin",
					"users.approve",
					"userscompliance.add",
				]),
				rejectusers: this.userHasPermission([
					"root",
					"admin",
					"users.reject",
					"userscompliance.deactivate",
				]),
				deleteuserkyc: this.userHasPermission([
					"root",
					"admin",
					"userscompliance.delete",
				]),

				viewusergroups: this.userHasPermission([
					"root",
					"admin",
					"usergroups.view",
					"usergroups.add",
					"usergroups.edit",
					"usergroups.delete",
				]),
				addusergroups: this.userHasPermission([
					"root",
					"admin",
					"usergroups.add",
				]),
				editusergroups: this.userHasPermission([
					"root",
					"admin",
					"usergroups.edit",
				]),
				deleteusergroups: this.userHasPermission([
					"root",
					"admin",
					"usergroups.delete",
				]),

				viewusersgrouppermissions: this.userHasPermission([
					"root",
					"admin",
					"grouppermissions.viewusers",
					"grouppermissions.viewpermissions",
					"grouppermissions.addusers",
					"grouppermissions.addpermissions",
					"grouppermissions.removeusers",
					"grouppermissions.removepermissions",
				]),
				viewpermissionsgrouppermissions: this.userHasPermission([
					"root",
					"admin",
					"grouppermissions.viewpermissions",
				]),
				addusersgrouppermissions: this.userHasPermission([
					"root",
					"admin",
					"grouppermissions.addusers",
				]),
				addpermissionsgrouppermissions: this.userHasPermission([
					"root",
					"admin",
					"grouppermissions.addpermissions",
				]),
				removeusersgrouppermissions: this.userHasPermission([
					"root",
					"admin",
					"grouppermissions.removeusers",
				]),
				removepermissionsgrouppermissions: this.userHasPermission([
					"root",
					"admin",
					"grouppermissions.removepermissions",
				]),

				viewuserscompliance: this.userHasPermission([
					"root",
					"admin",
					"userscompliance.view",
					"userscompliance.add",
					"userscompliance.edit",
					"userscompliance.deactivate",
				]),
				adduserscompliance: this.userHasPermission([
					"root",
					"admin",
					"userscompliance.add",
				]),
				edituserscompliance: this.userHasPermission([
					"root",
					"admin",
					"userscompliance.edit",
				]),
				deactivateuserscompliance: this.userHasPermission([
					"root",
					"admin",
					"userscompliance.confirm",
				]),

				viewcompanies: this.userHasPermission([
					"root",
					"admin",
					"companies.view",
					"companies.add",
					"companies.edit",
					"companies.delete",
				]),
				addcompanies: this.userHasPermission([
					"root",
					"admin",
					"companies.add",
				]),
				editcompanies: this.userHasPermission([
					"root",
					"admin",
					"companies.edit",
				]),
				deletecompanies: this.userHasPermission([
					"root",
					"admin",
					"companies.delete",
				]),

				viewexchangerates: this.userHasPermission([
					"root",
					"admin",
					"exchangerates.view",
					"exchangerates.add",
					"exchangerates.edit",
					"exchangerates.delete",
					"exchangerates.approve",
				]),
				addexchangerates: this.userHasPermission([
					"root",
					"admin",
					"exchangerates.add",
					"exchangerates.approve",
				]),
				editexchangerates: this.userHasPermission([
					"root",
					"admin",
					"exchangerates.edit",
					"exchangerates.approve",
				]),
				deleteexchangerates: this.userHasPermission([
					"root",
					"admin",
					"exchangerates.delete",
					"exchangerates.approve",
				]),
				approveexchangerates: this.userHasPermission([
					"root",
					"admin",
					"exchangerates.approve",
				]),

				viewtariffs: this.userHasPermission([
					"root",
					"admin",
					"tariffs.view",
					"tariffs.add",
					"tariffs.edit",
					"tariffs.delete",
				]),
				addtariffs: this.userHasPermission(["root", "admin", "tariffs.add"]),
				edittariffs: this.userHasPermission(["root", "admin", "tariffs.edit"]),
				deletetariffs: this.userHasPermission([
					"root",
					"admin",
					"tariffs.delete",
				]),

				viewtaxes: this.userHasPermission([
					"root",
					"admin",
					"taxes.view",
					"taxes.add",
					"taxes.edit",
					"taxes.delete",
				]),
				addtaxes: this.userHasPermission(["root", "admin", "taxes.add"]),
				edittaxes: this.userHasPermission(["root", "admin", "taxes.edit"]),
				deletetaxes: this.userHasPermission(["root", "admin", "taxes.delete"]),

				viewmobileprovider: this.userHasPermission([
					"root",
					"admin",
					"mobileprovider.view",
					"mobileprovider.add",
					"mobileprovider.edit",
					"mobileprovider.delete",
				]),
				addmobileprovider: this.userHasPermission([
					"root",
					"admin",
					"mobileprovider.add",
				]),
				editmobileprovider: this.userHasPermission([
					"root",
					"admin",
					"mobileprovider.edit",
				]),
				deletemobileprovider: this.userHasPermission([
					"root",
					"admin",
					"mobileprovider.delete",
				]),

				viewtransactions: this.userHasPermission([
					"root",
					"admin",
					"transactions.view",
				]),
				addtransactions: this.userHasPermission([
					"root",
					"admin",
					"transactions.add",
					"transactions.view",
				]),
				specialrates: this.userHasPermission([
					"root",
					"admin",
					"transactions.view",
					"specialrates.add",
				]),
				canceltransactions: this.userHasPermission([
					"root",
					"admin",
					"transactions.view",
					"transactions.cancel",
				]),
				payouttransactions: this.userHasPermission([
					"root",
					"admin",
					"transactions.view",
					"transactions.payout",
				]),
				reversetransactions: this.userHasPermission([
					"root",
					"admin",
					"transactions.view",
					"transactions.reverse",
				]),
				approvetransactions: this.userHasPermission([
					"root",
					"admin",
					"transactions.view",
					"transactions.approve",
				]),
				uncanceltransactions: this.userHasPermission([
					"root",
					"admin",
					"transactions.view",
					"transactions.uncancel",
				]),
				holdtransactions: this.userHasPermission([
					"root",
					"admin",
					"transactions.view",
					"transactions.hold",
				]),
				releasetransactions: this.userHasPermission([
					"root",
					"admin",
					"transactions.view",
					"transactions.release",
				]),
				viewtransactiontariffamount: this.userHasPermission([
					"root",
					"admin",
					"transactions.view",
					"transactions.viewtariffamount",
				]),
				viewtransactiontaxamount: this.userHasPermission([
					"root",
					"admin",
					"transactions.taxamount",
				]),
				banktransactionsreports: this.userHasPermission([
					"root",
					"admin",
					"transactions.banktransactionsreports",
				]),
				mobiletransactionsreports: this.userHasPermission([
					"root",
					"admin",
					"transactions.mobiletransactionsreports",
				]),
				viewtransactionexchangerate: this.userHasPermission([
					"root",
					"admin",
					"transactions.exchangerate",
				]),
				preapprovetransactions: this.userHasPermission([
					"root",
					"transactions.view",
					"transactions.preapprove",
				]),
				completetransactions: this.userHasPermission([
					"root",
					"transactions.view",
					"transactions.complete",
				]),
				completebotransactions: this.userHasPermission([
					"root",
					"transactions.view",
					"transactions.completebo",
				]),
				completewebtransactions: this.userHasPermission([
					"root",
					"transactions.view",
					"transactions.completeweb",
				]),
				viewtransactionroutes: this.userHasPermission([
					"root",
					"admin",
					"transactionroute.view",
				]),
				addtransactionroutes: this.userHasPermission([
					"root",
					"admin",
					"transactionroute.add",
				]),
				edittransactionroutes: this.userHasPermission([
					"root",
					"admin",
					"transactionroute.edit",
				]),
				deletetransactionroutes: this.userHasPermission([
					"root",
					"admin",
					"transactionroute.delete",
				]),

				viewtransactionrule: this.userHasPermission([
					"root",
					"admin",
					"transactionrule.view",
					"transactionrule.add",
					"transactionrule.edit",
					"transactionrule.delete",
				]),
				addtransactionrule: this.userHasPermission([
					"root",
					"admin",
					"transactionrule.add",
				]),
				edittransactionrule: this.userHasPermission([
					"root",
					"admin",
					"transactionrule.edit",
				]),
				deletetransactionrule: this.userHasPermission([
					"root",
					"admin",
					"transactionrule.delete",
				]),

				viewdocumenttype: this.userHasPermission([
					"root",
					"admin",
					"documenttype.view",
					"documenttype.add",
					"documenttype.edit",
					"documenttype.delete",
				]),
				adddocumenttype: this.userHasPermission([
					"root",
					"admin",
					"documenttype.add",
				]),
				editdocumenttype: this.userHasPermission([
					"root",
					"admin",
					"documenttype.edit",
				]),
				deletedocumenttype: this.userHasPermission([
					"root",
					"admin",
					"documenttype.delete",
				]),

				viewfinancing: this.userHasPermission([
					"root",
					"admin",
					"financing.view",
					"financing.add",
					"financing.edit",
					"financing.approve",
					"financing.delete",
				]),
				addfinancing: this.userHasPermission([
					"root",
					"admin",
					"financing.add",
				]),
				approvefinancing: this.userHasPermission([
					"root",
					"admin",
					"financing.approve",
				]),
				editfinancing: this.userHasPermission([
					"root",
					"admin",
					"financing.edit",
				]),
				removefinancing: this.userHasPermission([
					"root",
					"admin",
					"financing.delete",
				]),

				viewledgers: this.userHasPermission([
					"root",
					"admin",
					"ledgers.view",
					"ledgers.add",
					"ledgers.edit",
					"ledgers.approve",
					"ledgers.delete",
				]),
				addledgers: this.userHasPermission(["root", "admin", "ledgers.add"]),
				approveledgers: this.userHasPermission([
					"root",
					"admin",
					"ledgers.approve",
				]),
				editledgers: this.userHasPermission(["root", "admin", "ledgers.edit"]),
				removeledgers: this.userHasPermission([
					"root",
					"admin",
					"ledgers.delete",
				]),

				viewfinancingthreshhold: this.userHasPermission([
					"root",
					"admin",
					"financingthreshhold.view",
					"financingthreshhold.add",
					"financingthreshhold.edit",
					"financingthreshhold.delete",
				]),
				addfinancingthreshhold: this.userHasPermission([
					"root",
					"admin",
					"financingthreshhold.add",
				]),
				editfinancingthreshhold: this.userHasPermission([
					"root",
					"admin",
					"financingthreshhold.edit",
				]),
				deletefinancingthreshhold: this.userHasPermission([
					"root",
					"admin",
					"financingthreshhold.delete",
				]),

				viewsystemcategories: this.userHasPermission([
					"root",
					"admin",
					"systemcategories.view",
					"systemcategories.add",
					"systemcategories.edit",
					"systemcategories.delete",
				]),
				addsystemcategories: this.userHasPermission([
					"root",
					"admin",
					"systemcategories.add",
				]),
				editsystemcategories: this.userHasPermission([
					"root",
					"admin",
					"systemcategories.edit",
				]),
				deletesystemcategories: this.userHasPermission([
					"root",
					"admin",
					"systemcategories.delete",
				]),

				addprincipal: this.userHasPermission(["root", "admin"]),
				viewsystemlogs: this.userHasPermission(["root", "admin"]),

				//Reports
				smallworldReport: this.userHasPermission([
					"root",
					"admin",
					"transactions.smallWorldreports",
				]),
				generalreports: this.userHasPermission([
					"root",
					"admin",
					"generalreports.view",
				]),
				webAppReport: this.userHasPermission([
					"root",
					"admin",
					"webappreport.view",
					"transactions.boreport",
					"transactions.mobilereport",
				]),
				pendingTransactionsReport: this.userHasPermission([
					"root",
					"admin",
					"transactions.pendingtransactionsreport",
				]),
				loginFailureReport: this.userHasPermission([
					"root",
					"admin",
					"users.loginfailurereport",
				]),
				agencyReports: this.userHasPermission([
					"root",
					"admin",
					"agencyreports.view",
				]),
				viewusersReports: this.userHasPermission([
					"root",
					"admin",
					"users.reports",
				]),
				transactionsReports: this.userHasPermission([
					"root",
					"admin",
					"transactions.reports",
				]),
				partnerreports: this.userHasPermission([
					"root",
					"admin",
					"transactions.partnerreports",
				]),
				principleinboundreport: this.userHasPermission([
					"root",
					"admin",
					"transactions.principlereports",
				]),
				usersreports: this.userHasPermission([
					"root",
					"admin",
					"users.reports",
				]),
				userstransactionsreports: this.userHasPermission([
					"root",
					"admin",
					"users.transactionsreports",
				]),
				customersreports: this.userHasPermission([
					"root",
					"admin",
					"users.customersreports",
				]),
				userstransactionsummaryreports: this.userHasPermission([
					"root",
					"admin",
					"users.transactionsummaryreports",
				]),
				xoomreports: this.userHasPermission([
					"root",
					"admin",
					"transactions.xoomreports",
				]),
				//
				showSettingsTitle: false,
			};

			menuItems.showSettingsTitle =
				menuItems.viewexchangerates ||
				menuItems.viewtransactionrule ||
				menuItems.viewtariffs ||
				menuItems.viewtaxes ||
				menuItems.viewmobileprovider ||
				menuItems.viewdocumenttype;

			return menuItems;
		},
	},
	created() {
		this.getUserPermissions();
	},
	mixins: [ApiServiceMixin, UtilitiesMixins, MessagesMixin],
};
